/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginWithSamlRequest } from '../../models/login-with-saml-request';
import { LoginWithSamlResult } from '../../models/login-with-saml-result';

export interface PostLoginSaml$Params {
  body?: LoginWithSamlRequest;
}

export function postLoginSaml(
  http: HttpClient,
  rootUrl: string,
  params?: PostLoginSaml$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LoginWithSamlResult>> {
  const rb = new RequestBuilder(rootUrl, postLoginSaml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginWithSamlResult>;
    }),
  );
}

postLoginSaml.PATH = '/Authentication/login/saml';
